<template>
  <div class="chat-map-item">
    <div class="map-message">
      <el-skeleton
          style="width: 100%"
          :loading="showSkeleton"
          animated
          :throttle="{ leading: 500, trailing: 500, initVal: true }"
          v-if="message.msgJsonContent.mindMapImgUrl == ''"
        >
        <template #template>
          <!-- <el-skeleton-item variant="image" style="width: 240px; height: 265px" /> -->
          <div style="display: flex; flex-direction: column; width: 100%; margin-top: 10px;" >
            <el-skeleton-item variant="image" style="width: 100%; height: 200px;" />
          </div>
        </template>
      </el-skeleton>
      <div style="display: flex; flex-direction: column; position: relative; margin-top: 10px;" v-if="message.msgJsonContent.mindMapImgUrl && message.msgJsonContent.mindMapImgUrl?.length > 0">
        <CommonImage ref="imageRef" :hideOnClickModal="true" :src="message.msgJsonContent.mindMapImgUrl" :zIndex="999" :previewSrcList="[message.msgJsonContent.mindMapImgUrl]" fit="fill" style="min-height: 200px;" alt @load="handleImageLoad" @error="handleImageError"/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {defineEmits, watch} from "vue";
import type { Message } from "@/data/chat/Message";
let call = defineEmits(["updateContentHeight", "resetSendQusition", "proBuy"])

interface Props {
  message: Message
}
const props = defineProps<Props>()
const showSkeleton = ref(true)

watch(() => props.message.msgJsonContent.mindMapImgUrl, (newParams, oldParams) => {
  if (oldParams != newParams) {
    showSkeleton.value = true
  }
},{
  deep: true
});

function handleImageLoad() {
  console.log("handleImageLoad")
  showSkeleton.value = false
}

function handleImageError() {
  console.log("handleImageError")
}

onMounted(()=>{
  call("updateContentHeight")
})

</script>

<style lang="less">
.chat-map-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  .map-message {
    position: relative;
  }
}
</style>

<style lang="less">
.chat-map-item {
  /* 覆盖预览页关闭按钮样式 */
  .el-image-viewer__close {
    color: black;
    font-size: 24px;
    background-color: white;
    border-radius: 50%;
  }
}

</style>